import {atom} from 'jotai';

/**
 * Where the open search panel was opened from (SEARCH_SHOWN's `source`).
 * `home_directory` is the home search box after the /people redirect.
 */
export const showSearchAtom = atom<
  false | 'home' | 'home_directory' | 'keyboard' | 'people' | 'nav' | 'queryparam'
>(false);
export const filterAtom = atom<'all' | 'teams' | 'people'>('all');
